import { render, staticRenderFns } from "./profileSection.vue?vue&type=template&id=58fc7935&scoped=true"
import script from "./profileSection.vue?vue&type=script&lang=js"
export * from "./profileSection.vue?vue&type=script&lang=js"
import style0 from "./profileSection.vue?vue&type=style&index=0&id=58fc7935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc7935",
  null
  
)

export default component.exports